import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/common/logo.svg'


const _hoisted_1 = { class: "p-signup l-container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"p-signup__ttl c-ttl\"><span class=\"p-signup__ttl__logo\"><img src=\"" + _imports_0 + "\" alt=\"SHUEISHA ID\"></span>確認コード入力</h1><div class=\"p-messages\"><div class=\"c-message\"><p class=\"c-message__txt c-message__txt--primary\"><i></i><span>メールアドレスに届いた確認コードを入力してください。</span></p></div></div>", 2)
const _hoisted_4 = { class: "p-signin__field-container" }
const _hoisted_5 = { class: "p-errors" }
const _hoisted_6 = { class: "c-error" }
const _hoisted_7 = { class: "p-fields" }
const _hoisted_8 = { class: "c-field" }
const _hoisted_9 = { class: "c-field__body" }
const _hoisted_10 = { class: "c-field__input" }
const _hoisted_11 = { class: "c-field has-submit has-mt" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "送信する", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "p-signin__txt" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("確認コードが届かない場合は ")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "コードを再送する", -1)
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Form, {
      onSubmit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.asyncDeterringWrap(_ctx.confirmConfirmationCode, this))),
      "validation-schema": _ctx.schema
    }, {
      default: _withCtx(({ errors, meta }) => [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.errorMsgRef), 1)
          ], 512), [
            [_vShow, _ctx.errorMsgRef]
          ]),
          _createElementVNode("fieldset", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "confirmationCode",
                    modelValue: _ctx.confirmationCodeRef,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.confirmationCodeRef) = $event)),
                    placeholder: "確認コードを入力",
                    required: ""
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.confirmationCode), 513), [
              [_vShow, errors.confirmationCode]
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "submit",
                class: "c-btn is-submit",
                disabled: !meta.valid || _ctx.isDeterringRef
              }, _hoisted_14, 8, _hoisted_12)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"]),
    _createElementVNode("p", _hoisted_15, [
      _hoisted_16,
      _createElementVNode("a", {
        class: "c-link c-link--primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.asyncDeterringWrap(_ctx.resendConfirmationCode, this)))
      }, _hoisted_18)
    ])
  ]))
}